<template>
  <div class="course-session--control">
    <div
      v-if="sessionCount > 0"
      :class="['course-session-tiles', { 'course-session-tabs': numberOfMonths > 1 }]"
      data-ui="available-sessions"
    >
      <cdr-text
        class="course-session-tiles__heading"
        data-ui="available-sessions-heading"
        tag="h2"
      >
        <template v-if="sessionCount !== 0">
          {{ sessionCount }}
        </template>
        {{ sessionsAvailableText }}
      </cdr-text>
      <template v-if="numberOfMonths === 1">
        <cdr-list
          v-for="(sessionsList, monthName) in sessionsByMonth"
          :key="monthName"
          data-ui="session-card-list-single-month"
          class="course-session-tiles__list"
        >
          <cards-component
            v-for="(session, index) in sessionsList"
            :key="session.sessionId"
            :index="index"
            :session="session"
            :single-month="true"
          />
          <li
            v-if="sessionCount >= 8"
            class="course-session-tiles__show-more"
          >
            <cdr-button
              modifier="secondary"
              data-ui="show-more-results"
              @click="showMoreResults"
            >
              Show more results
            </cdr-button>
          </li>
        </cdr-list>
      </template>
      <cdr-tabs
        v-if="numberOfMonths > 1"
        height="auto"
        modifier="centered"
        data-ui="course-session-tabs"
      >
        <cdr-tab-panel
          v-for="(sessionsList, monthName) in sessionsByMonth"
          :key="monthName"
          :name="monthName.replace(/\s\d+/, '')"
          class="course-session-tiles__tab"
          @tab-change="onTabChange"
        >
          <cdr-list
            :data-ui="`session-card-list-multi-month`"
            :class="`course-session-tiles__list ${monthName.replace(/\s\d+/, '')}`"
          >
            <cards-component
              v-for="(session, index) in sessionsList"
              :key="session.sessionId"
              :index="index"
              :session="session"
            />
          </cdr-list>
        </cdr-tab-panel>
      </cdr-tabs>
    </div>
    <cdr-text
      v-else
      class="course-sessions__no-sessions"
      data-ui="no-available-sessions"
      modifier="heading-serif-600"
    >
      {{ sessionsAvailableText }}
    </cdr-text>
  </div>
</template>

<script>
// TODO: Remove this file when A/B test ends and target wins
import { CdrButton, CdrList, CdrTabs, CdrTabPanel, CdrText } from '@rei/cedar';
import CardsComponent from './CardsComponent.vue';
import metrics from '../mixins/metrics';

export default {
  name: 'FilterByMonthComponent',
  components: {
    CdrButton,
    CdrList,
    CdrTabs,
    CdrTabPanel,
    CdrText,
    CardsComponent,
  },
  mixins: [metrics],
  props: {
    sessionsByMonth: {
      type: Object,
      required: true,
    },
    sessionCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      noSessionsAvailableText:
        'Looks like no sessions are scheduled right now. Please bookmark this page and check back soon.',
    };
  },
  computed: {
    sessionsAvailableMessage() {
      const { sessionCount } = this;
      let sessionsAvailableMessage;
      if (sessionCount === 0) {
        sessionsAvailableMessage = this.noSessionsAvailableText;
      }
      if (sessionCount === 1) {
        sessionsAvailableMessage = `${sessionCount} session available`;
      }
      if (sessionCount > 1) {
        sessionsAvailableMessage = `${sessionCount} sessions available`;
      }
      return sessionsAvailableMessage;
    },
    sessionsAvailableText() {
      const { noSessionsAvailableText, sessionCount } = this;
      let sessionsAvailableText = noSessionsAvailableText;
      if (sessionCount !== 0) {
        sessionsAvailableText = sessionCount === 1 ? 'session available' : 'sessions available';
      }
      return sessionsAvailableText;
    },
    numberOfMonths() {
      return Object.keys(this.sessionsByMonth).length;
    },
  },
  methods: {
    onTabChange(tabState, tabId) {
      if (tabState !== false) {
        this.metricsClick({ linkName: `{{ pageName }}_date tab_${tabId}` });
      }
    },
    showMoreResults() {
      const moreResults = document.querySelector('.course-session-tiles__show-more');
      const hiddenTiles = document.querySelectorAll('.opo-card--hidden');
      if (hiddenTiles.length) {
        for (let i = 0; i < hiddenTiles.length; i += 1) {
          hiddenTiles[i].classList.remove('opo-card--hidden');
        }
        moreResults.classList.add('cdr-display-none');
      }
    },
  },
};
</script>
